import { render, staticRenderFns } from "./TopDealsSliderEntry.vue?vue&type=template&id=8cd766c4&scoped=true"
import script from "./TopDealsSliderEntry.vue?vue&type=script&lang=js"
export * from "./TopDealsSliderEntry.vue?vue&type=script&lang=js"
import style0 from "./TopDealsSliderEntry.vue?vue&type=style&index=0&id=8cd766c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd766c4",
  null
  
)

export default component.exports